import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChange,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { Footer, MessageService } from 'primeng/api';
import { OverlayPanel } from 'primeng/overlaypanel';

import { LocalDatePipe } from 'src/app/modules/shared/pipes/local-date.pipe';
import {
  combineLatest,
  concatMap,
  finalize,
  lastValueFrom,
  Subject,
  takeUntil,
} from 'rxjs';
import { debounce, debounceTime, switchMap, tap } from 'rxjs/operators';
import { WhatsAppService } from 'src/app/misc/campaign/services/whatsapp.service';
import { AccountUserService } from '../../../../service/account.service';
import { FileUpload } from 'primeng/fileupload';
import { ConversationMessageService } from '../../../../misc/campaign/services/conversation-message.service';
import { MessageHandler } from './message-handler';
import { ConversationVM } from '../../../../misc/campaign/models/vm/conversation-vm';
import { PusherService } from '../../../../misc/campaign/services/pusher.service';
import { AppMainComponent } from '../../../../app.main.component';
import { environment } from '../../../../../environments/environment';
import {
  PusherConversation,
  PusherConversationVM,
} from '../../../../misc/campaign/models/pusher-conversation';
import { AppMainService } from '../../../../app-main.service';
import { FormControl } from '@angular/forms';
import { AudioRecordingService } from './audio-recording.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ContactHttpService } from '../../services/contact.http.service';
import { convertWavToMp3 } from './audio.helper';


@Component({
  selector: 'app-campaign-inbox',
  templateUrl: './inbox.component.html',
  styleUrls: ['./inbox.component.scss'],
  providers: [LocalDatePipe, WhatsAppService],
})
export class CampaignInboxComponent implements OnInit, OnChanges, OnDestroy {
  @Input() display;
  @Input() state;
  @Input() isWhatsapp;
  @Input() isSMS;
  @Input() isEmail;
  @Input() isonlyMsg;
  @Input() selectedMenu;
  @Input() selectedConversation;
  @Input() expiredSubscriptionData;
  @Output() cancelClicked = new EventEmitter();
  

  @ViewChild('scrollMe') private myScrollContainer: ElementRef;
  @ViewChild('phonePanel') phonePanel: OverlayPanel;
  @ViewChild('loggedPanel') loggedPanel: OverlayPanel;
  @ViewChild('fileUpload') fileUpload: FileUpload;
  assestBaseUrl: string = environment.assestsBasePath;
  displayEditFlow:boolean = false;
  whatsAppMemberInfo:any;
  innerheight;
  stateOptions = [
    { label: 'Direct', value: 'direct' },
    /*{ label: 'Group', value: 'group' },*/
  ];
  searchContacts:string;
  allChatsSMS = [
    {
      id: 1,
      name: 'Amber Wang',
      image: 'sms.png',
      status: 'read',
      messages: [
        {
          id: 1,
          type: 'sent',
          message: 'Hi, how are you?',
          time: 'Mon May 1 2022 09:00:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 2,
          type: 'sent',
          message: 'I am Josephin Water',
          time: 'Wed May 1 2022 09:30:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 3,
          type: 'receive',
          message: 'Hello, how are you?',
          time: 'Wed May 1 2022 11:30:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 4,
          type: 'sent',
          message:
            'Long time no contact with you, I need your help, please call me ASAP.',
          time: 'Wed May 1 2022 11:35:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 5,
          type: 'sent',
          message: 'Hi, how are you?',
          time: 'Mon Nov 16 2023 13:00:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 6,
          type: 'sent',
          message: 'I am Josephin Water',
          time: 'Mon Nov 16 2023 13:04:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 7,
          type: 'receive',
          message: 'Hello, how are you?',
          time: 'Tue Nov 17 2023 08:00:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 8,
          type: 'sent',
          message:
            'Long time no contact with you, I need your help, please call me ASAP.',
          time: 'Tue Nov 17 2023 09:00:00 GMT-0400 (Eastern Daylight Time)',
        },
      ],
      accountName: 'Company 1',
      online: true,
      phone: [
        { id: 1, phone: '732-888-5846' },
        { id: 2, phone: '555-995-5655' },
      ],
    },
    {
      id: 2,
      name: 'Jony Lynetln',
      image: '',
      status: 'unread',
      messages: [
        {
          id: 1,
          type: 'sent',
          message: 'Hi, how are you? I am from Company 2',
          time: new Date(),
        },
        { id: 2, type: 'receive', message: 'Hello', time: new Date() },
        {
          id: 3,
          type: 'sent',
          message:
            'Long time no contact with you, I need your help, please call me ASAP.',
          time: new Date(),
        },
        {
          id: 4,
          type: 'receive',
          message:
            'Long time no contact with you, I need your help, please call me ASAP.',
          time: new Date(),
        },
        {
          id: 5,
          type: 'receive',
          message:
            'Long time no contact with you, I need your help, please call me ASAP.',
          time: new Date(),
        },
      ],
      accountName: 'Company 2',
      online: false,
      phone: [{ id: 1, phone: '732-888-5846' }],
    },
    {
      id: 3,
      name: 'Sophia Elija',
      image: '',
      status: 'sending',
      messages: [
        { id: 1, type: 'sent', message: 'Hi, how are you?', time: new Date() },
        { id: 2, type: 'sent', message: 'I am Sophia Elija', time: new Date() },
        {
          id: 3,
          type: 'receive',
          message: 'Hello, how are you?',
          time: new Date(),
        },
        {
          id: 4,
          type: 'sent',
          message:
            'Long time no contact with you, I need your help, please call me ASAP.',
          time: new Date(),
        },
      ],
      accountName: 'Company 3',
      online: false,
      phone: [
        { id: 1, phone: '732-888-5846' },
        { id: 2, phone: '555-995-5655' },
      ],
    },
    {
      id: 4,
      name: 'Emma Watson',
      image: '',
      status: 'error',
      messages: [
        {
          id: 1,
          type: 'receive',
          message:
            'Hi I am Emma, can you help me to find best chat app? Hi I am Emma, can you help me to find best chat app?',
          time: 'Wed Nov 21 2022 09:30:00 GMT-0400 (Eastern Daylight Time)',
        },
      ],
      accountName: 'Company 4',
      online: true,
      phone: [
        { id: 1, phone: '732-888-5846' },
        { id: 2, phone: '555-995-5655' },
      ],
    },
    {
      id: 5,
      name: 'Josephin Water',
      image: 'panda.jpg',
      status: 'read',
      messages: [
        {
          id: 1,
          type: 'sent',
          message: 'Hi, how are you?',
          time: 'Mon May 1 2022 09:00:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 2,
          type: 'sent',
          message: 'I am Josephin Water',
          time: 'Wed May 1 2022 09:30:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 3,
          type: 'receive',
          message: 'Hello, how are you?',
          time: 'Wed May 1 2022 11:30:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 4,
          type: 'sent',
          message:
            'Long time no contact with you, I need your help, please call me ASAP.',
          time: 'Wed May 1 2022 11:35:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 5,
          type: 'sent',
          message: 'Hi, how are you?',
          time: 'Mon Nov 16 2023 13:00:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 6,
          type: 'sent',
          message: 'I am Josephin Water',
          time: 'Mon Nov 16 2023 13:04:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 7,
          type: 'receive',
          message: 'Hello, how are you?',
          time: 'Tue Nov 17 2023 08:00:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 8,
          type: 'sent',
          message:
            'Long time no contact with you, I need your help, please call me ASAP.',
          time: 'Tue Nov 17 2023 09:00:00 GMT-0400 (Eastern Daylight Time)',
        },
      ],
      accountName: 'Company 1',
      online: true,
      phone: [{ id: 1, phone: '732-888-5846' }],
    },
    {
      id: 6,
      name: 'Jony Lynetln',
      image: '',
      status: 'unread',
      messages: [
        {
          id: 1,
          type: 'sent',
          message: 'Hi, how are you? I am from Company 2',
          time: new Date(),
        },
        { id: 2, type: 'receive', message: 'Hello', time: new Date() },
        {
          id: 3,
          type: 'sent',
          message:
            'Long time no contact with you, I need your help, please call me ASAP.',
          time: new Date(),
        },
        {
          id: 4,
          type: 'receive',
          message:
            'Long time no contact with you, I need your help, please call me ASAP.',
          time: new Date(),
        },
        {
          id: 5,
          type: 'receive',
          message:
            'Long time no contact with you, I need your help, please call me ASAP.',
          time: new Date(),
        },
      ],
      accountName: 'Company 2',
      online: false,
      phone: [{ id: 1, phone: '732-888-5846' }],
    },
    {
      id: 7,
      name: 'Sophia Elija',
      image: '',
      status: 'sending',
      messages: [
        { id: 1, type: 'sent', message: 'Hi, how are you?', time: new Date() },
        { id: 2, type: 'sent', message: 'I am Sophia Elija', time: new Date() },
        {
          id: 3,
          type: 'receive',
          message: 'Hello, how are you?',
          time: new Date(),
        },
        {
          id: 4,
          type: 'sent',
          message:
            'Long time no contact with you, I need your help, please call me ASAP.',
          time: new Date(),
        },
      ],
      accountName: 'Company 3',
      online: false,
      phone: [{ id: 1, phone: '732-888-5846' }],
    },
    {
      id: 8,
      name: 'Emma Watson',
      image: '',
      status: 'error',
      messages: [
        {
          id: 1,
          type: 'receive',
          message:
            'Hi I am Emma, can you help me to find best chat app? Hi I am Emma, can you help me to find best chat app?',
          time: 'Wed Nov 21 2022 09:30:00 GMT-0400 (Eastern Daylight Time)',
        },
      ],
      accountName: 'Company 4',
      online: true,
      phone: [{ id: 1, phone: '732-888-5846' }],
    },
    {
      id: 9,
      name: 'Josephin Water',
      image: 'panda.jpg',
      status: 'read',
      messages: [
        {
          id: 1,
          type: 'sent',
          message: 'Hi, how are you?',
          time: 'Mon May 1 2022 09:00:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 2,
          type: 'sent',
          message: 'I am Josephin Water',
          time: 'Wed May 1 2022 09:30:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 3,
          type: 'receive',
          message: 'Hello, how are you?',
          time: 'Wed May 1 2022 11:30:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 4,
          type: 'sent',
          message:
            'Long time no contact with you, I need your help, please call me ASAP.',
          time: 'Wed May 1 2022 11:35:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 5,
          type: 'sent',
          message: 'Hi, how are you?',
          time: 'Mon Nov 16 2023 13:00:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 6,
          type: 'sent',
          message: 'I am Josephin Water',
          time: 'Mon Nov 16 2023 13:04:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 7,
          type: 'receive',
          message: 'Hello, how are you?',
          time: 'Tue Nov 17 2023 08:00:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 8,
          type: 'sent',
          message:
            'Long time no contact with you, I need your help, please call me ASAP.',
          time: 'Tue Nov 17 2023 09:00:00 GMT-0400 (Eastern Daylight Time)',
        },
      ],
      accountName: 'Company 1',
      online: true,
      phone: [{ id: 1, phone: '732-888-5846' }],
    },
    {
      id: 10,
      name: 'Jony Lynetln',
      image: '',
      status: 'unread',
      messages: [
        {
          id: 1,
          type: 'sent',
          message: 'Hi, how are you? I am from Company 2',
          time: new Date(),
        },
        { id: 2, type: 'receive', message: 'Hello', time: new Date() },
        {
          id: 3,
          type: 'sent',
          message:
            'Long time no contact with you, I need your help, please call me ASAP.',
          time: new Date(),
        },
        {
          id: 4,
          type: 'receive',
          message:
            'Long time no contact with you, I need your help, please call me ASAP.',
          time: new Date(),
        },
        {
          id: 5,
          type: 'receive',
          message:
            'Long time no contact with you, I need your help, please call me ASAP.',
          time: new Date(),
        },
      ],
      accountName: 'Company 2',
      online: false,
      phone: [{ id: 1, phone: '732-888-5846' }],
    },
    {
      id: 11,
      name: 'Sophia Elija',
      image: '',
      status: 'sending',
      messages: [
        { id: 1, type: 'sent', message: 'Hi, how are you?', time: new Date() },
        { id: 2, type: 'sent', message: 'I am Sophia Elija', time: new Date() },
        {
          id: 3,
          type: 'receive',
          message: 'Hello, how are you?',
          time: new Date(),
        },
        {
          id: 4,
          type: 'sent',
          message:
            'Long time no contact with you, I need your help, please call me ASAP.',
          time: new Date(),
        },
      ],
      accountName: 'Company 3',
      online: false,
      phone: [{ id: 1, phone: '732-888-5846' }],
    },
    {
      id: 12,
      name: 'Emma Watson',
      image: '',
      status: 'error',
      messages: [
        {
          id: 1,
          type: 'receive',
          message:
            'Hi I am Emma, can you help me to find best chat app? Hi I am Emma, can you help me to find best chat app?',
          time: 'Wed Nov 21 2022 09:30:00 GMT-0400 (Eastern Daylight Time)',
        },
      ],
      accountName: 'Company 4',
      online: true,
      phone: [{ id: 1, phone: '732-888-5846' }],
    },
  ];
  chats = [];
  loggedUser = {
    id: 1,
    name: 'Logged User',
    image: '',
    status: 'read',
    messages: [
      { id: 1, type: 'sent' },
      { id: 2, type: 'sent' },
      { id: 3, type: 'receive' },
      { id: 4, type: 'sent' },
    ],
    accountName: 'Company 111',
    online: true,
    phone: [
      { id: 1, phone: '990-334-8884' },
      { id: 2, phone: '345-785-2432' },
    ],
  };
  selectedIndex: number = null;
  activeUser;
  selectedPhone;
  selectedLogged = this.loggedUser.phone[0];
  chatInputMessage = '';
  sets = [
    'native',
    'google',
    'twitter',
    'facebook',
    'emojione',
    'apple',
    'messenger',
  ];
  set = 'twitter';

  tempImg;
  displayImg = false;
  displayFiles = false;

  //group
  displayGroup = false;
  tempGroup = {
    id: 0,
    name: '',
    contacts: [],
    image: '',
    status: '',
    messages: [],
  };
  contacts = [
    { id: 1, name: 'Jack Ma', image: 'panda.jpg' },
    { id: 2, name: 'Sophia Song', image: '' },
    { id: 3, name: 'User 3', image: '' },
    { id: 4, name: 'User 4', image: '' },
    { id: 5, name: 'User 5', image: '' },
    { id: 6, name: 'User 6', image: '' },
    { id: 7, name: 'User 7', image: '' },
    { id: 8, name: 'User 8', image: '' },
    { id: 9, name: 'User 9', image: '' },
    { id: 10, name: 'Logged User', image: 'cookie.jpg' },
  ];
  selectedContacts = [];
  groups = [];
  allGroups = [
    {
      id: 1,
      name: 'Group 1',
      contacts: [
        { id: 1, name: 'User 1' },
        { id: 2, name: 'User 2' },
        { id: 3, name: 'User 3' },
        {
          id: 4,
          name: 'User 4',
        },
      ],
      image: 'nopCommerce.png',
      status: 'read',
      messages: [
        {
          id: 1,
          name: 'User 1',
          image: 'panda.jpg',
          type: 'receive',
          message: 'Hi, this is Susan? I am from Company 2',
          time: 'Mon May 1 2022 09:00:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 2,
          name: 'User 2',
          image: '',
          type: 'receive',
          message: 'Hello',
          time: 'Mon May 1 2022 09:06:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 3,
          name: 'User 4',
          image: '',
          type: 'receive',
          message:
            'Long time no contact with you, I need your help, please call me ASAP.',
          time: 'Mon May 1 2022 10:00:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 4,
          name: 'User 1',
          image: 'panda.jpg',
          type: 'receive',
          message: 'Hi, this is Susan? I am from Company 2',
          time: 'Mon May 1 2022 09:00:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 5,
          name: 'User 1',
          image: 'panda.jpg',
          type: 'receive',
          message: 'Hello',
          time: 'Mon May 1 2022 09:06:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 6,
          name: 'Logged User',
          image: 'cookie.jpg',
          type: 'sent',
          message:
            'Long time no contact with you, I need your help, please call me ASAP.',
          time: 'Mon May 1 2022 10:00:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 7,
          name: 'User 3',
          image: '',
          type: 'receive',
          message: 'Hi, this is Susan? I am from Company 2',
          time: 'Mon May 1 2022 09:00:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 8,
          name: 'User 1',
          image: 'panda.jpg',
          type: 'receive',
          message: 'Hello',
          time: 'Mon May 1 2022 09:06:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 9,
          name: 'Logged User',
          image: 'cookie.jpg',
          type: 'sent',
          message:
            'Long time no contact with you, I need your help, please call me ASAP.',
          time: 'Mon May 1 2022 10:00:00 GMT-0400 (Eastern Daylight Time)',
        },
      ],
    },
    {
      id: 2,
      name: 'Group 2',
      contacts: [
        { id: 2, name: 'User 2' },
        { id: 3, name: 'User 3' },
        { id: 4, name: 'User 4' },
      ],
      image: '',
      status: 'error',
      messages: [
        {
          id: 1,
          name: 'User 1',
          image: 'panda.jpg',
          type: 'receive',
          message: 'Hi, this is Susan? I am from Company 2',
          time: 'Mon Nov 15 2022 09:00:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 2,
          name: 'User 2',
          image: '',
          type: 'receive',
          message: 'Hello',
          time: 'Mon Nov 16 2022 09:06:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 3,
          name: 'User 4',
          image: '',
          type: 'receive',
          message:
            'Long time no contact with you, I need your help, please call me ASAP.',
          time: 'Mon Nov 17 2022 10:00:00 GMT-0400 (Eastern Daylight Time)',
        },
        {
          id: 4,
          name: 'Logged User',
          image: 'cookie.jpg',
          type: 'sent',
          message:
            'Long time no contact with you, I need your help, please call me ASAP.',
          time: 'Mon Nov 17 2022 10:00:00 GMT-0400 (Eastern Daylight Time)',
        },
      ],
    },
    {
      id: 3,
      name: 'Group 3',
      contacts: [
        { id: 2, name: 'User 2' },
        { id: 3, name: 'User 3' },
        { id: 4, name: 'User 4' },
      ],
      image: '',
      status: 'unread',
      messages: [],
    },
  ];
  uploadedFiles: {
    file: File;
    caption: string;
    type: string;
    objectUrl: string;
  }[] = [];
  activeGroup;
  isRepeat = false;

  //pagination
  public page = 1;
  public pageSize = 10;
  public first: number = 0;
  public totalRows: number = 0;

  // template message
  templateMessages = [];
  selectedInboxTemplate: any;

  destroy$: Subject<void> = new Subject<void>();
  sentNewDirectMessage$: Subject<string> = new Subject<string>();
  sentMediaMessage$: Subject<any> = new Subject<any>();

  destroyTimer$: Subject<void>;
  whatsAppMessagesList = [];

  // reply message
    selectedReplyMsg = null;

    menus = [
      {id:1,name:"Reply"},
      {id:2,name:"React"},
      // {id:3,name:"Report"},
      // {id:4,name:"Delete"},
    ];
    selectedReplyMenu;
    isShowMenu = [];
    isReply = false;
    tempMsg;
    emojis = [
      {id:1,emoji:"👍"},
      {id:2,emoji:"💗"},
      {id:3,emoji:"😂"},
      {id:4,emoji:"😯"},
      {id:5,emoji:"😅"},
      {id:6,emoji:"🙏"},
    ];
    reactMsg:any;
    displayReport = false;
    displayDeleteMsg = false;
    @ViewChild('emojiMenu') emojiMenu: OverlayPanel;
    reactionResponse:any;

    //recording
    isRecording = false;
    recordedTime;
    blobUrl;
    blobUrlAudio;
    teste;

    private searchSubject = new Subject<string>();
    @ViewChild('msgInput') _textArea: ElementRef;
    // formControl = new FormControl(this.chatInputMessage);
    
    displayAddEditContact:boolean = false;
    selectedContact;
    selectedSubMenu;
    contactHeader;
    identifiedCountry: {
      countryName: string;
      countryCode: number;
      phoneNumber: string;
    };
    private ngUnsubscribe = new Subject<void>();
    countryList:any[] = [];
    @ViewChild('audioPlayer') audioPlayer!: ElementRef<HTMLAudioElement>;
    flowFormList:any[] = [];
    selectedFlow:any;
  constructor(
    private app: AppMainComponent,
    private appMainService: AppMainService,
    private messageService: MessageService,
    private whatsAppService: WhatsAppService,
    private userService: AccountUserService,
    private pusherService: PusherService,
    private conversationMessageService: ConversationMessageService,
    private datePipe: DatePipe,
    private audioRecordingService: AudioRecordingService,
    private sanitizer: DomSanitizer,
    private contactHttpService: ContactHttpService,
    private cd: ChangeDetectorRef,
  ) {
    this.searchDebounce();
    this.getScreenSize();

    // recording
    this.audioRecordingService
      .recordingFailed()
      .subscribe(() => (this.isRecording = false));
    this.audioRecordingService
      .getRecordedTime()
      .subscribe(time => {
        this.recordedTime = time;
      });
    this.audioRecordingService.audioBlob$.subscribe(data => {
      this.teste = data;
      this.blobUrl = this.sanitizer.bypassSecurityTrustUrl(
        URL.createObjectURL(data.blob)
      );
      this.blobUrlAudio =  URL.createObjectURL(data?.blob);
      this.cd.detectChanges();
    });
  }

  ngOnInit(): void {
    if(this.activeUser?.name == 'Unknown'){
      this.getCountryCode();
    }
    if(this.expiredSubscriptionData?.statusId == 2){
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Your subscription has been expired. Please renew your subscription to continue using the service.'
      });
    }
    this.userService.user
      .pipe(
        tap((user) => (this.loggedUser.name = user.userName)),
        takeUntil(this.destroy$)
      )
      .subscribe();

    if (this.isWhatsapp && this.isonlyMsg) {
      this.subscribeToPusher();
    }

    this.sentNewDirectMessage$
      .pipe(
        concatMap((messageText) => {
          const message = {
            recipientPhoneNo: this.selectedPhone.phone,
            phoneNoId: this.selectedConversation.internalPhoneNoId,
            body: messageText,
            messageContext: this.isReply ? {messageId: this.tempMsg?.whatsAppMessageId} : null,
          };
          setTimeout(() => this.scrollToBottom());
          return this.whatsAppService.sentMessage(message);
        }),
        takeUntil(this.destroy$)
      )
      .subscribe({
        next:(response:any)=>{
          // console.log(response);
          // this.whatsAppMessagesList.forEach((listData)=>{
          //   if(listData?.whatsAppMessageId == response?.reply?.replyMessageId){
          //     // replyMsg: m.reply || null,
          //     // messageContextId:m.messageContextId || null,
          //     // reaction: m.reaction || null,
          //     // receiverName: m.receiverName || null,
          //     // contextType: m.contextType || null,
          //     listData.replyMsg = response?.reply?.msgType;
          //     console.log("listData",listData);
          //   }
          // })
        }
      });

    this.sentMediaMessage$
      .pipe(
        concatMap((message) => this.whatsAppService.sentMediaMessage(message)),
        tap(() => {
          this.chatInputMessage = '';
          this.fileUpload.clear();
        }),
        takeUntil(this.destroy$),
        finalize(() => {
          this.appMainService.isHideSpinner('sentMediaMessage');
        })
      )
      .subscribe((data)=>{
        this.isReply = false;
        this.clearRecordedData();
        this.appMainService.isHideSpinner('sentMediaMessage');
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.initSetIndex();
    this.innerheight = window.innerHeight;
    this.scrollToBottom();
    if(changes?.expiredSubscriptionData?.currentValue){
      this.expiredSubscriptionData = changes?.expiredSubscriptionData?.currentValue;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.unbindPusherEvent();
    this.abortRecording();

  }

  unbindPusherEvent() {
    this.pusherService.channel.unbind(environment.pusher.events.newMessage);
    this.pusherService.channel.unbind(environment.pusher.events.statusChange);
  }

  cancel() {
    this.cancelClicked.emit();
  }

  getShortName(fullName) {
    return fullName
      .split(' ')
      .map((n) => n[0])
      .join('');
  }

  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop =
        this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) {}
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.innerheight = window.innerHeight - 300;
  }

  async initSetIndex(): Promise<void> {
    if (this.isWhatsapp) {
      if (!this.isonlyMsg) {
        const res = await lastValueFrom(
          this.whatsAppService.getConversations({
            pageNumber: this.page,
            pageSize: this.pageSize,
          })
        );
        this.chats = (res.data || []).map((c) => ConversationVM.toVM(c));
        this.page = res.pageNumber;
        this.pageSize = res.pageSize;
        this.totalRows = res?.total||0;

        if (!this.selectedIndex) {
          this.selectedConversation = this.chats[0] ?? null;
          this.setIndex(0, this.selectedConversation);
        }
      }
    } else if (this.isSMS) {
      this.chats = JSON.parse(JSON.stringify(this.allChatsSMS));
    }
    this.groups = JSON.parse(JSON.stringify(this.allGroups));

    if (this.state == 'direct') {
      if (!this.selectedConversation) {
        this.setIndex(0, this.chats[0]);
      } else {
        this.activeUser = this.selectedConversation;
      }
    } else if (this.state == 'group') {
      this.setIndex(0, this.allGroups[0]);
    }
  }

  setIndex(i, user) {
    this.selectedIndex = i;
    if (this.state == 'direct') {
      this.activeUser = user;
      this.selectedConversation = user;
      if (this.isWhatsapp && !this.isonlyMsg) {
        this.chats[i].unreadMessageCount = 0;
        this.unbindPusherEvent();
        this.subscribeToPusher();
      }
    } else if (this.state == 'group') {
      this.activeGroup = user;
    }
  }

  onPageChange($event){
    this.page = $event?.page + 1;
    this.searchContacts = '';
    this.initSetIndex();
  }

  handleEnterKey(event: KeyboardEvent,msgInput): void {
    event.preventDefault(); // Prevents the new line from being added
    this.addNewMessage(msgInput); // Your method to save the message
}

  addNewMessage(inputField) {
    let val;
    if(inputField){
      val = inputField?.value?.trim();
    }else{
      val = this.chatInputMessage?.trim();
    }
    if (val.length) {
      if (this.state == 'direct') {
        if (this.fileUpload.files.length > 0) {
          this.sentMediaMessage(this.fileUpload.files, val);
        } else {
          this.sentNewDirectMessage$.next(val);
          this.isReply = false;
        }
      } else if (this.state == 'group') {
        this.activeGroup.messages.push({
          id: this.activeGroup.messages.length + 1,
          type: 'sent',
          message: val,
          time: new Date().toISOString(),
        });
      }
    }else{
      if (this.blobUrl) {
        this.sentMediaMessage(null, val, this.blobUrlAudio);
      }
    }
    if(inputField){
      inputField.value = '';
    }else{
      this.chatInputMessage = '';
    }
  }

  getLatestDate(user) {
      const d = new Date(user.lastMessageDateTime);
      if (d.getDate() == new Date().getDate()) {
        return 'Today';
      } else if (d.getDate() == new Date().getDate() - 1) {
        return 'Yesterday';
      } else {
        var datePipe = new DatePipe('en-US');
        return datePipe.transform(d, 'MM/dd/yyyy');
      }
  }

  isDifferentDay(messageIndex: number): boolean {
    if (messageIndex === 0) return true;

    if (this.state == 'direct') {
      const d1 = new Date(this.whatsAppMessagesList[messageIndex - 1].time);
      const d2 = new Date(this.whatsAppMessagesList[messageIndex].time);

      return (
        d1.getFullYear() !== d2.getFullYear() ||
        d1.getMonth() !== d2.getMonth() ||
        d1.getDate() !== d2.getDate()
      );
    } else if (this.state == 'group') {
      const d1 = new Date(this.activeGroup?.messages[messageIndex - 1].time);
      const d2 = new Date(this.activeGroup?.messages[messageIndex].time);

      return (
        d1.getFullYear() !== d2.getFullYear() ||
        d1.getMonth() !== d2.getMonth() ||
        d1.getDate() !== d2.getDate()
      );
    }
  }

  getMessageDate(messageIndex: number): string {
    if (this.state == 'direct') {
      const wholeDate = new Date(
        this.whatsAppMessagesList[messageIndex].time
      ).toDateString();
      return wholeDate;
    } else if (this.state == 'group') {
      const wholeDate = new Date(
        this.whatsAppMessagesList[messageIndex].time
      ).toDateString();
      return wholeDate;
    }
  }

  isSameYear(messageIndex: number): boolean {
    if (this.state == 'direct') {
      const d = new Date(this.whatsAppMessagesList[messageIndex].time);
      return d.getFullYear() == new Date().getFullYear();
    } else if (this.state == 'group') {
      const d = new Date(this.whatsAppMessagesList[messageIndex].time);
      return d.getFullYear() == new Date().getFullYear();
    }
  }

  isToday(messageIndex: number): boolean {
    if (this.state == 'direct') {
      const d = new Date(this.whatsAppMessagesList[messageIndex].time);
      return d.getDate() == new Date().getDate();
    } else if (this.state == 'group') {
      const d = new Date(this.whatsAppMessagesList[messageIndex].time);
      return d.getDate() == new Date().getDate();
    }
  }

  isYesterday(messageIndex: number): boolean {
    if (this.state == 'direct') {
      const d = new Date(this.whatsAppMessagesList[messageIndex].time);
      return d.getDate() == new Date().getDate() - 1;
    } else if (this.state == 'group') {
      const d = new Date(this.whatsAppMessagesList[messageIndex].time);
      return d.getDate() == new Date().getDate() - 1;
    }
  }

  addEmoji(e) {
    this.chatInputMessage = this.chatInputMessage + e.emoji.native;
  }

  handleChange(e) {
    /*if (this.state == 'direct') {
                    if (e.checked) {
                        if (this.isWhatsapp) {
                            this.chats = this.allChatsWhatsapp.filter(
                                (e) => e.status == 'unread',
                            );
                        } else if (this.isSMS) {
                            this.chats = this.allChatsSMS.filter((e) => e.status == 'unread');
                        }
                        this.setIndex(0, this.chats[0]);
                    } else {
                        if (this.isWhatsapp) {
                            this.chats = this.allChatsWhatsapp;
                        } else if (this.isSMS) {
                            this.chats = this.allChatsSMS;
                        }
                        this.setIndex(0, this.chats[0]);
                    }
                } else if (this.state == 'group') {
                    if (e.checked) {
                        this.groups = this.allGroups.filter((e) => e.status == 'unread');
                        this.setIndex(0, this.groups[0]);
                    } else {
                        this.groups = this.allGroups;
                        this.setIndex(0, this.groups[0]);
                    }
                }*/
  }

  //group

  addGroup() {
    this.tempGroup = {
      id: 0,
      name: '',
      contacts: [],
      image: '',
      status: '',
      messages: [],
    };
    this.displayGroup = true;
  }

  isRepeatName(name) {
    for (let s of this.allGroups) {
      if (name == s.name) {
        this.isRepeat = true;
        break;
      } else {
        this.isRepeat = false;
        this.saveGroup();
      }
    }
  }

  saveGroup() {
    this.tempGroup.id = this.allGroups.length + 1;
    this.tempGroup.contacts = JSON.parse(JSON.stringify(this.selectedContacts));
    this.allGroups.push(this.tempGroup);
    this.displayGroup = false;
  }

  onUpload(event) {
    for (let file of event.files) {
      this.uploadedFiles.push(file);
    }
    this.messageService.add({
      severity: 'info',
      summary: 'File Uploaded',
      detail: '',
    });
  }

  onRowSelectPhone(e) {
    this.whatsAppService
      .setTemplateMessage({
        messagingProduct: 'whatsapp',
        to: this.selectedPhone.phone,
        type: 'template',
        template: {
          name: 'hello_world',
          language: {
            code: 'en_US',
          },
        },
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe();
    this.phonePanel.hide();
  }

  onRowSelectLogged(e) {
    this.loggedPanel.hide();
  }

  async sentTemplateMessage($event: any) {
    const templateMessage = {
      phoneNoId: this.selectedConversation.internalPhoneNoId,
      recipientPhoneNo: this.selectedConversation.phone[0].phone,
      payload: {
        name: $event.value.name,
        language: {
          code: $event.value.language,
        },
        components: [],
      },
    };

    await lastValueFrom(
      this.whatsAppService.setTemplateMessage(templateMessage)
    );
    this.selectedInboxTemplate = null;
  }

  async urlToFile(url, filename, mimeType) {
    const response = await fetch(url);
    const data = await response.blob();
    return new File([data], filename, { type: mimeType });
  }


  async sentMediaMessage(files: File[], caption: string, blobUrl?: any) {
    let fileUp;
    if (files?.length > 0 && files[0] instanceof File) {
      fileUp = files[0];
    } else if(blobUrl) {
      fileUp = await this.urlToFile(blobUrl, this.teste?.title, "audio/mpeg");
    }
    let message = {
      file: fileUp,
      phoneNoId: this.selectedConversation.internalPhoneNoId,
      recipientPhoneNo: this.selectedConversation.phone[0].phone,
      caption: caption,
      messageContext: this.isReply ? this.tempMsg?.whatsAppMessageId : null,
    };
    if(blobUrl){
      message['type'] = 'audio';
    }
    this.appMainService.isShowSpinner('sentMediaMessage');
    this.sentMediaMessage$.next(message);
  }

  clearSelectedMedia(): void {
    this.fileUpload.clear();
    this.uploadedFiles.forEach((f) => {
      if (f.objectUrl) URL.revokeObjectURL(f.objectUrl);
    });
    this.uploadedFiles = [];
    this.displayFiles = false;
  }

  private async subscribeToPusher() {
    this.whatsAppMessagesList = [];
    let conversation;
    const prevMessages = await lastValueFrom(
      this.whatsAppService.getMessages(this.selectedConversation.id)
    );
    this.whatsAppMemberInfo = prevMessages;
    const internalMember = prevMessages.internalMember.id;
    const externalMember = prevMessages.externalMember.id;
    const messages = (prevMessages?.messages ?? []).map((m) => {
      return MessageHandler.toMessage(m, internalMember, externalMember);
    });

    this.whatsAppMessagesList.push(...messages);
    setTimeout(() => this.scrollToBottom(), 100);
    // console.log("whatsAppMessagesList",this.whatsAppMessagesList);
    // Bind to newMessage Event
    this.pusherService
      .subscribeChannel(this.app.user.organizationId)
      .bind(environment.pusher.events.newMessage, (res: PusherConversation) => {
        const chat = this.chats.find((c) => c.id === res.Group.Id);
        if (chat) {
          conversation = PusherConversationVM.toVM(res);
          conversation.internalPhoneNo = chat.internalPhoneNo;
          chat.unreadMessageCount = res.Group.UnreadMessageCount;
          chat.lastMessage = conversation.lastMessage;
          chat.subscribed = res.Subscribed;
        }else{
          conversation = PusherConversationVM.toVM(res);
        }
        if (this.selectedConversation.id === res.Group.Id) {
          this.selectedConversation = conversation;
          this.setIndex(0, this.selectedConversation);
          if(this.chats?.length > 0){
            this.chats.forEach((c) => {  
              if (c.id === this.selectedConversation?.id) {
                c.lastExternalMessageDate = this.selectedConversation?.lastExternalMessageDate;
                c.expired = this.selectedConversation?.expired;
                c.subscribed = this.selectedConversation?.subscribed;
                c.lastMessageDateTime = this.selectedConversation?.lastMessageDateTime;
                c.memberType = this.selectedConversation?.memberType;
              }
            });
          }
          if(this.selectedConversation?.memberType == 'external'){
            this.chats = this.chats.sort((a, b) => new Date(b.lastExternalMessageDate).getTime() - new Date(a.lastExternalMessageDate).getTime());
          }else{
            this.chats = this.chats.sort((a, b) => new Date(b.lastMessageDateTime).getTime() - new Date(a.lastMessageDateTime).getTime());
          }
          const message = PusherConversationVM.toLastMessage(res);
          message.createdDate = new Date().toISOString();
          const lastMessage = MessageHandler.toMessage(
            message,
            internalMember,
            externalMember
          );
          // console.log("lastMessage",lastMessage);
          const exist = this.whatsAppMessagesList.find(msg=> msg.id==lastMessage.id);
          if(exist){
            this.whatsAppMessagesList.map(msg=>{
              if(msg.id == lastMessage.id){
                msg.reaction = lastMessage?.reaction;
              }
            })
          }else{
            this.whatsAppMessagesList.push(lastMessage);
          }
          // if(!exist) this.whatsAppMessagesList.push(lastMessage);
        }

        setTimeout(() => this.scrollToBottom(), 100);
        // console.log('count');
      });

    const deliveryStatus = (m) => {
      if (m.StatusFailed) return 'failed';
      if (m.StatusRead) return 'read';
      if (m.StatusDelivered) return 'delivered';
      if (m.StatusSent) return 'sent';
      return 'pending';
    };

    this.pusherService
      .subscribeChannel(this.app.user.organizationId)
      .bind(environment.pusher.events.statusChange, (res) => {
        const chat = this.chats.find((c) => c.id === res.GroupId);
        if (chat) {
          chat.lastMessage.status = deliveryStatus(res);
        }
        const msg = this.whatsAppMessagesList.find((m) => m.id === res.Id);
        if (msg) {
          msg.deliveryStatus = deliveryStatus(res);
          msg.deliveryMessage = res.DeliveryMessage;
        }
      });

    this.loggedUser.phone = this.selectedConversation.internalPhoneNo;
    if (this.selectedConversation) {
      this.activeUser = {
        ...this.activeUser,
        name: this.selectedConversation.name
          ? this.selectedConversation.name
          : this.activeUser.name,
        accountName: this.selectedConversation.accountName,
        phone: this.selectedConversation.phone,
      };
      this.selectedPhone = this.selectedConversation.phone[0];
    }

    const templates = await lastValueFrom(
      this.whatsAppService.getMessageTemplates()
    );

    this.flowFormList = await lastValueFrom(
      this.whatsAppService.getFlowDropDown()
    );
    // debugger;
    this.templateMessages = templates.filter((t) => {
      const components = t?.components ? JSON.parse(t?.components) : [];
      const body = (components ?? []).find((c) => c.type === 'BODY');
      const exampleBodyText = !!body?.example?.body_text[0]?.length;
      return (
        t.status === 'APPROVED' &&
        t.active === true &&
        t.type === 'text' &&
        !exampleBodyText
      );
    });
    // console.log("chats",this.chats);
  }

  openImg(message) {
    this.tempImg = message;
    this.displayImg = true;
  }

  async openFiles() {
    const fileList = this.fileUpload.files;
    this.uploadedFiles = Array.from(fileList).map((file) => {
      const type = this.getFileTypeFromMimeType(file.type) || 'document';
      const objectUrl =
      type === 'audio' || type === 'video'
        ? this.createObjectURL(file)
        : null;
      return {
      file,
      caption: '',
      type,
      objectUrl,
      };
    });
    // console.log("uploadedFiles",this.uploadedFiles);
    this.displayFiles = !!this.uploadedFiles.find(
      (f) => f.type === 'image' || f.type === 'audio' || f.type === 'video' || f.type === 'document'
    );

    if (!this.displayFiles) {
      const files$ = this.uploadedFiles.map((f) => {
        const message = {
          file: f.file,
          phoneNoId: this.selectedConversation.internalPhoneNoId,
          recipientPhoneNo: this.selectedConversation.phone[0].phone,
          type: f.type,
         messageContext: this.isReply ?  this.tempMsg?.whatsAppMessageId : null,
        };
        return this.whatsAppService.sentMediaMessage(message);
      });
      try {
        this.appMainService.isShowSpinner('sentDocumentMessage');
        await lastValueFrom(combineLatest(files$));
        this.isReply =false;
        this.appMainService.isHideSpinner('sentDocumentMessage');
      } catch {
        this.appMainService.isHideSpinner('sentDocumentMessage');
      }
      this.fileUpload.clear();
      this.uploadedFiles = [];
    }
  }

  getFileTypeFromMimeType(mimeType: string): string | null {
    switch (mimeType.toLowerCase()) {
      case 'image/jpeg':
      case 'image/png':
      case 'image/gif':
      case 'image/svg+xml':
        return 'image';
      case 'audio/mpeg':
      case 'audio/wav':
      case 'audio/ogg':
      case 'audio/aac':
        return 'audio';
      case 'video/mp4':
      case 'video/webm':
        return 'video';
      case 'application/pdf':
      case 'application/msword':
      case 'application/rtf':
      case 'application/xml':
      case 'application/vnd.ms-excel':
      case 'text/xml':
      case 'text/plain':
        return 'document';
      default:
        return null; // Return null for unknown MIME types
    }
  }

  cancelFile() {
    this.fileUpload.clear();
    this.displayFiles = false;
  }

  async sendFiles() {
    // this.sentMediaMessage(this.fileUpload.files, '');
    const files$ = this.uploadedFiles.map((f) => {
      const message = {
        file: f.file,
        phoneNoId: this.selectedConversation.internalPhoneNoId,
        recipientPhoneNo: this.selectedConversation.phone[0].phone,
        type: f.type,
        caption: f.caption,
        messageContext: this.isReply ?  this.tempMsg?.whatsAppMessageId : null,
      };
      return this.whatsAppService.sentMediaMessage(message);
    });
    try {
      this.appMainService.isShowSpinner('sentMediaMessage');
      await lastValueFrom(combineLatest(files$));
      this.isReply = false;
      this.fileUpload.clear();
      this.uploadedFiles.forEach((f) => {
        if (f.objectUrl) URL.revokeObjectURL(f.objectUrl);
      });
      this.uploadedFiles = [];
      this.displayFiles = false;
      this.appMainService.isHideSpinner('sentMediaMessage');
    } catch (e) {
      this.appMainService.isHideSpinner('sentMediaMessage');
      this.fileUpload.clear();
      this.uploadedFiles.forEach((f) => {
        if (f.objectUrl) URL.revokeObjectURL(f.objectUrl);
      });
      this.uploadedFiles = [];
    }
  }

  createObjectURL(file: File) {
    return URL.createObjectURL(file);
  }

  async resendMessage(msg: any) {
    try {
      this.appMainService.isShowSpinner('resendMessage');
      await lastValueFrom(
        this.whatsAppService.resendMessage(msg.whatsAppMessageId)
      );
      this.appMainService.isHideSpinner('resendMessage');
    } catch (error) {
      this.appMainService.isHideSpinner('resendMessage');
      this.messageService.add({
        severity: 'error',
        summary: 'Error!',
        detail: `Error occurring when resend message. ${
          error?.error ? error.error : ''
        }`,
      });
    }
  }


  //reply message
  replyMessage(msg: any) {
    this.selectedReplyMsg = msg;
  }
  getMsgValue(value) {
    this.tempMsg = JSON.parse(JSON.stringify(value));
    // console.log("tempMsg",this.tempMsg);
  }
  removeReply() {
    this.isReply = false;
    this.tempMsg = null;
  }
  
  changeReplyMenu(e,msg) {
    if (e.value.name == "Reply") {
      this.isReply = true;
      const textArea = this._textArea.nativeElement as HTMLTextAreaElement;
      textArea.focus();
      textArea.setSelectionRange(0, 0);
    } else if (e.value.name == "React") {
      this.reactMsg = msg;
      this.emojiMenu.toggle(event);
    } else if (e.value.name == "Report") {
      this.displayReport = true;
    } else if (e.value.name == "Delete") {
      this.displayDeleteMsg = true;
    }
    this.selectedReplyMenu = null;
  }

  formatMsgBody(msg: any): string {
    let body = msg?.body;
    const params = body?.match(/\{{([1-9][0-9]*)}}/gm);

    if (params && params.length) {
      for (const [index, p] of params.entries()) {
        // const num = parseInt(p.match(/[1-9][0-9]*/)[0], 10);
        if (msg.payload?.body && index < msg.payload.body.length) {
          body = body.replace(p, msg.payload.body[index].text ?? '');
        } else {
          body = body.replace(p, '');
        }
      }
    }

    return body ?? '';
  }


  reactionMsg(event,msg){
    this.appMainService.isShowSpinner('reactionMsg');
    let requestBody = {
      recipientPhoneNo: this.selectedPhone?.phone,
      phoneNoId: this.selectedConversation?.internalPhoneNoId || 8,
      reaction: {
        messageId: this.reactMsg ? this.reactMsg?.whatsAppMessageId : msg?.whatsAppMessageId,
        emoji: event?.emoji,
      },
      contactCRMDetailsDto: {
        moduleName: this.whatsAppMemberInfo?.externalMember?.moduleName,
        moduleRecordId: this.whatsAppMemberInfo?.externalMember?.moduleRecordId,
        moduleRecordName: this.whatsAppMemberInfo?.externalMember?.moduleRecordName,
        contactName: this.whatsAppMemberInfo?.externalMember?.contactName,
        contactId: this.whatsAppMemberInfo?.externalMember?.contactId,
      }
    };
    this.whatsAppService.emojiReaction(requestBody).subscribe({
      next:(response)=>{
        this.reactionResponse = response;
        if(this.reactMsg){
          this.reactMsg.reaction = this.reactionResponse?.reaction?.emoji;
        }else{
          msg.reaction = this.reactionResponse?.reaction?.emoji;
        }
        this.appMainService.isHideSpinner('reactionMsg');
      },
      error:(error)=>{
        this.appMainService.isHideSpinner('reactionMsg');
      }
    });
  }

  // async onSearchChange(event){
  //   const res = await lastValueFrom(
  //     this.whatsAppService.getConversations({
  //       pageNumber: this.page,
  //       pageSize: this.pageSize,
  //       isMessengerSearch: true,
  //       searchKeyword: this.searchContacts,
  //     })
  //   );
  //   this.chats = (res.data || []).map((c) => ConversationVM.toVM(c));
  // }

  searchDebounce() {
    this.searchSubject.pipe(
      debounceTime(1500), // wait 3sec after the last event before emitting last event
      switchMap(searchKeyword => this.whatsAppService.getConversations({
        pageNumber: this.page,
        pageSize: this.pageSize,
        isMessengerSearch: true,
        searchKeyword: searchKeyword,
      }))
    ).subscribe(res => {
      this.chats = (res.data || []).map((c) => ConversationVM.toVM(c));
    });
  }

  onSearchChange(event) {
    // Use next on the subject to trigger the API call
    this.searchSubject.next(this.searchContacts);
  }
  removeOutline(){
    let container = document.getElementById("box");
    let ele = container.getElementsByTagName('li');
    for (var i = 0; i < ele.length; i++) {
      ele[i].classList.remove('outline');
    }
  }
  openScroll(msg){
    if (msg?.messageContextId) {
        const element = document.getElementById(msg?.messageContextId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          element.classList.add('outline');
        }
    }
  }

  //recording
  startRecording(){
    if (!this.isRecording) {
      this.isRecording = true;
      this.audioRecordingService.startRecordingNew();
    }
  }
  abortRecording() {
    if (this.isRecording) {
      this.isRecording = false;
      this.audioRecordingService.abortRecording();
    }
  }

  stopRecording() {
    if (this.isRecording) {
      this.audioRecordingService.stopRecordingNew();
      this.isRecording = false;
    }
  }
  clearRecordedData() {
    this.blobUrl = null;
  }

  addContact(){
    this.contactHeader = 'Add New Contact List';
    this.displayAddEditContact = true;
    this.selectedContact = null;
    this.selectedSubMenu = null;
    this.identifiedCountry = this.identifyCountry(this.selectedPhone.phone);
  }

  onCancelContact(){
    this.displayAddEditContact = false;
  }

  newContactCreated(event){
    this.displayAddEditContact = false;
  }

   identifyCountry(phoneNumber: string): {
    countryName: string;
    countryCode: number;
    phoneNumber: string;
  } | null {
    for (let i = 1; i <= 4; i++) {
      const code = parseInt(phoneNumber.slice(0, i), 10);
      const country = this.countryList.find(country => parseInt(country.PhoneCode) === code);
      if (country) {
        const remainingNumber = phoneNumber.slice(i);
        return {
          countryName: country.CountryName,
          countryCode: country.PhoneCode,
          phoneNumber: remainingNumber
        };
      }
    }
    return null;
  }

  getCountryCode() {
    this.contactHttpService.countryCode().pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        {
          next: (response:any[]) => {
            this.countryList = response;
        },
          error: (error) => {
            this.appMainService.isHideSpinner('authenSetUp');
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error?.error?.message ? error?.error?.message : 'please try again...'
            });

          },
          complete: () => { },
        });
  }

  sentFlowMessage(event){
    this.displayEditFlow = true;
  }


  submitFlowResponse(event){
    this.appMainService.isShowSpinner('submitFlowResponse');
    const flowMessage = {
      phoneNoId: this.selectedConversation.internalPhoneNoId,
      flowId: this.selectedFlow?.id,
      header: event?.header,
      footer: event?.footer,
      body: event?.body,
      actionName: event?.ctaText,
      contactCRMDetails: {
        phoneNo: this.whatsAppMemberInfo?.externalMember?.phoneNumber,
        moduleName: this.whatsAppMemberInfo?.externalMember?.moduleName,
        moduleRecordId: this.whatsAppMemberInfo?.externalMember?.moduleRecordId,
        moduleRecordName: this.whatsAppMemberInfo?.externalMember?.moduleRecordName,
        contactName: this.whatsAppMemberInfo?.externalMember?.contactName,
        contactId: this.whatsAppMemberInfo?.externalMember?.contactId
      },
    };
    this.whatsAppService.sendFlowOnMessenger(flowMessage).subscribe({
      next:(data)=>{
        this.displayEditFlow = false;
        this.selectedFlow = null;
        this.appMainService.isHideSpinner('submitFlowResponse');
      },
      error:(error)=>{
        this.appMainService.isHideSpinner('submitFlowResponse');
      }
    })
  }

  getObjectKeys(obj: any):any {
    return Object.keys(obj)
  }

  onSaveEditFlow(){
    this.displayEditFlow = false;
    this.selectedFlow = null;
  }
  
}
